import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.promise.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { useLanguageStore } from '@/store/modules/language';
import { UseVerifyAccount } from '@/views/mall/verifyAccount/useVerifyAccount';
import { CommonConstants } from '@/common/constants';
console.log('process.env.VUE_APP_API_BASE_URL', process.env.VUE_APP_API_BASE_URL);
// 创建axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 120 * 1000,
  // 超时
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求错误处理
const onError = function (error) {
  if (error.message.includes('timeout')) {
    ElMessage({
      message: 'request timeout',
      type: 'error'
    });
  }
  return error;
};

// 请求拦截
instance.interceptors.request.use(function (config) {
  config.headers = _objectSpread(_objectSpread({}, config.headers), {}, {
    'web-source': sessionStorage.getItem('source') || ''
  });
  return _objectSpread({}, config);
}, onError);

// 响应拦截
instance.interceptors.response.use(function (response) {
  const {
    data
  } = response;
  // token过期，清空绑定信息
  if (data.code === -20) {
    const {
      clearVerifyRole
    } = UseVerifyAccount();
    clearVerifyRole();
  }
  if (response && response.data) {
    return Promise.resolve(response);
  }
  return Promise.reject(new Error('response error'));
}, onError);
const request = async function (config) {
  try {
    const {
      data
    } = await instance.request(config);
    if (data.code === 0) {
      if (config.successToast) {
        ElMessage({
          message: data.msg || 'success',
          type: 'success'
        });
      }
      return data;
    }
    if (config.errorToast) {
      ElMessage({
        message: data.msg,
        type: 'info'
      });
    }
    return data;
  } catch (err) {
    return {
      code: -1,
      msg: err.message || 'request error',
      data: null
    };
    // ElMessage({
    //   message: data.msg,
    //   type: 'info'
    // })
    // return data
  }
};

/**
 *
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const getRequest = function (url, params = {}, successToast = false, errorToast = true) {
  return request({
    url,
    method: 'get',
    params,
    successToast,
    errorToast
  });
};

/**
 *  post接口默认提示成功和失败
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const postRequest = function (url, params, successToast = false, errorToast = true, headers = {}) {
  return request({
    url,
    method: 'post',
    data: params,
    headers: headers || {},
    successToast,
    errorToast
  });
};

/**
 *  post商城接口默认提示成功和失败，统一添加lang,access_token
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const postRequestMall = function (url, params, successToast = false, errorToast = true, headers = {}) {
  const {
    currentLanguage
  } = useLanguageStore();
  const lang = CommonConstants.IS_AREA === 'cn' ? 'zh' : currentLanguage.key || 'en';
  // try {
  //
  //   // lang = JSON.parse(localStorage.getItem('languageStore') || '{}').currentLanguage.key || 'en'
  //   console.log('lang, getasdasd', lang, url)
  // } catch (error) {
  //   lang = 'en'
  // }
  // if (params?.lang) {
  //   console.log('lang===000>', lang, url)
  //   lang = params.lang
  // }
  const token = getMysToken() || getToken();
  // let token = getToken()
  // if (url.includes('/role/roles')) {
  //   token = getMysToken()
  // }
  return request({
    url,
    method: 'post',
    data: {
      lang,
      data: params,
      access_token: token,
      web_source: sessionStorage.getItem('source') || ''
    },
    headers: headers || {},
    successToast,
    errorToast
  });
};

/**
 *  post接口默认提示成功和失败
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const deleteRequest = function (url, params = {}, successToast = true, errorToast = true) {
  return request({
    url,
    method: 'delete',
    data: params,
    successToast,
    errorToast
  });
};
const getToken = function () {
  const {
    path
  } = window.globalRoute;
  const localTokens = JSON.parse(localStorage.getItem('tokens') || '{}');
  return localTokens[path] || '';
};
// 获取摸鱼社的token
const getMysToken = function () {
  const {
    path
  } = window.globalRoute;
  const localTokens = JSON.parse(localStorage.getItem('mysTokens') || '{}');
  return localTokens[path] || '';
};